import React from 'react'
import { formatNumber } from 'utils/utils'
import './RangeSlider.scss'

let lockSlider

export default class RangeSlider extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      min: this.props.min || this.props.minLimit,
      max: this.props.max || this.props.maxLimit,
      minElement: null,
      maxElement: null,
      minRange: this.props.minRange || 0,
      dragging: false,
    }
  }

  componentDidMount() {
    if (!this.props.singleSlider && this.refs.minElement) {
      this.refs.minElement.value = min
    }
    if (this.refs.maxElement) {
      this.refs.maxElement.value = max
    }
    let min = this.props.min || this.props.minLimit
    let { max } = this.props

    if (!this.props.singleSlider) {
      this.refs.minElement.value = min
    }
    this.refs.maxElement.value = max
    this.setState({ min, max })
    this.checkBrowser()
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (this.props.min != prevProps.min && this.state.min == prevState.min) ||
      (this.props.max != prevProps.max && this.state.max == prevState.max)
    ) {
      this.changeValue(this.props.min, this.props.max)
      return false
    }
    if (this.state.max != prevState.max || this.state.min != prevState.min) {
      this.props.handleChange(this.state.min, this.state.max)
    }
    if (this.props.responsive.browser != prevProps.responsive.browser) {
      this.checkBrowser()
    }
  }

  checkBrowser() {
    if (
      this.props.responsive.browser == 'edge' ||
      this.props.responsive.browser == 'msie'
    ) {
      const timeout = setTimeout(
        function () {
          if (!this.props.singleSlider) {
            this.refs.minElement.value = this.props.min || this.props.minLimit
          }
          this.refs.maxElement.value = this.props.max || this.props.maxLimit
        }.bind(this),
        50
      )
    }
  }

  changeValue(minValue, maxValue) {
    minValue =
      Math.floor(parseInt(minValue) / this.props.step) * this.props.step
    maxValue =
      Math.floor(parseInt(maxValue) / this.props.step) * this.props.step
    if (maxValue > this.props.maxLimit - this.props.minRange) {
      maxValue = this.props.maxLimit
    }
    if (minValue < this.props.minLimit + this.props.minRange) {
      minValue = this.props.minLimit
    }
    if (!this.props.singleSlider) {
      this.refs.minElement.value = minValue
    }
    this.refs.maxElement.value = maxValue
    this.setState(
      { min: minValue, max: maxValue },
      this.props.handleChange(minValue, maxValue)
    )
  }

  handleSliderChange(position) {
    if (position) {
      const { width } = this.refs.outerBG.getBoundingClientRect()
      const minValue = this.state.min
      const maxValue = this.state.max
      const { minLimit } = this.props
      const { maxLimit } = this.props
      const clickedValue = Math.floor(
        (position / width) * (maxLimit - minLimit) + minLimit
      )
      const threshold = (minValue + maxValue) / 2
      if (
        !this.props.singleSlider &&
        clickedValue <= threshold &&
        lockSlider != 'max'
      ) {
        lockSlider = 'min'
        this.changeValue(clickedValue, maxValue) // changes min value
      } else if (
        this.props.singleSlider ||
        (clickedValue >= threshold && lockSlider != 'min')
      ) {
        lockSlider = 'max'
        this.changeValue(minValue, clickedValue) // changes max value
      }
    }
  }

  handleMouseMove(e) {
    if (this.state.dragging) {
      this.handleSliderChange(e.nativeEvent.offsetX + 8)
    }
  }

  handleTouchMove(e) {
    let position = e.nativeEvent.targetTouches[0].pageX - this.refs.outerBG.getBoundingClientRect().left;
    position > this.refs.outerBG.getBoundingClientRect().width && (position = this.refs.outerBG.getBoundingClientRect().width);
    position < 0 && (position = 0);
    if (this.state.dragging) {
      this.handleSliderChange(position)
    }
  }

  handleClick(e) {
    this.handleSliderChange(e.nativeEvent.offsetX)
  }

  renderClass() {
    let className = 'range-slide-holder'
    if (this.state.dragging) {
      className += ' is--dragging'
    }
    if (
      this.props.responsive.browser == 'edge' ||
      this.props.responsive.browser == 'msie'
    ) {
      className += ' is--ms'
    }
    return className
  }

  renderBarStyle() {
    const style = {
      marginLeft: `calc(-8px + ${
        ((this.state.min - this.props.minLimit) /
          (this.props.maxLimit - this.props.minLimit)) *
        100
      }% )`,
      width: `calc(8px + ${
        100 -
        ((this.state.min -
          this.props.minLimit +
          this.props.maxLimit -
          this.state.max) /
          (this.props.maxLimit - this.props.minLimit)) *
          100
      }% )`,
    }
    return style
  }

  renderMinPrice() {
    if (!this.props.responsive.mobileVersion) {
      return (
        <div className="slider-min-price">
          {`R$${this.state.min === 0 ? '0' : formatNumber(this.state.min)}`}
        </div>
      )
    }
    return ''
  }

  renderMaxPrice() {
    if (!this.props.responsive.mobileVersion) {
      return (
        <div className="slider-max-price">
          {this.props.maxLimit === this.state.max
            ? ''
            : `R$${formatNumber(this.state.max)}`}
        </div>
      )
    }
    return ''
  }

  render() {
    return (
      <div className={this.renderClass()}>
        {this.renderMinPrice()}
        <div className="price-range-slider">
          <div
            className="slider-bg-outer"
            ref="outerBG"
            onClick={e => {
              this.handleSliderChange(e.nativeEvent.offsetX)
            }}
            onMouseMove={this.handleMouseMove.bind(this)}
            onMouseDown={() => {
              this.setState({ dragging: true }, (lockSlider = undefined))
            }}
            onMouseUp={() => {
              this.setState({ dragging: false })
            }}
            onMouseOut={() => {
              this.setState({ dragging: false }, (lockSlider = undefined))
            }}
            onTouchMove={this.handleTouchMove.bind(this)}
            onTouchStart={() => {
              this.setState({ dragging: true }, (lockSlider = undefined))
            }}
            onTouchEnd={() => {
              this.setState({ dragging: false })
            }}
            onTouchCancel={() => {
              this.setState({ dragging: false }, (lockSlider = undefined))
            }}
          >
            <div className="slider-bg-inner" style={this.renderBarStyle()} />
          </div>
          {!this.props.singleSlider ? (
            <input
              onChange={e => {
                if (e.target.value < this.state.max - this.state.minRange) {
                  this.setState({ min: parseInt(e.target.value) })
                } else {
                  this.refs.minElement.value = this.state.min
                  this.setState({ min: parseInt(this.state.min) })
                }
              }}
              ref="minElement"
              min={this.props.minLimit}
              max={this.props.maxLimit}
              step={this.props.step}
              type="range"
              value={this.state.min}
            />
          ) : (
            ''
          )}
          <input
            onChange={e => {
              const value = parseInt(e.target.value)
              if (value >= this.state.min + this.state.minRange) {
                this.setState({ max: value })
              } else {
                this.refs.maxElement.value = this.state.max
                this.setState({ max: this.state.max })
              }
            }}
            ref="maxElement"
            min={this.props.minLimit}
            max={this.props.maxLimit}
            step={this.props.step}
            type="range"
            value={this.state.max}
          />
        </div>
        {this.renderMaxPrice()}
      </div>
    )
  }
}
